import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TimesheetConfigurationModelParsed } from './types';
import { QUERY_KEY_SETTINGS_TIMESHEET_BASIC } from '@/lib/api/constants';
import { updateTimesheetBasicSettings } from './updateTimesheetBasicSettings';
import { mapTimesheetBasicSettingsParsedToRaw } from './parseTimesheetBasicSettings';

/**
 * Handles saving Basic Configuration data via PUT.
 */
export function useMutationTimesheetBasicSettings(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: TimesheetConfigurationModelParsed) => {
      const parsed = mapTimesheetBasicSettingsParsedToRaw(payload)
      const { data } = await updateTimesheetBasicSettings({ companyId, payload: parsed });
      return data;
    },

    onError: (error) => {
      // @TODO handle error properly
      // show notification to user 
      console.error('Error saving basic settings:', error);
    },

    onSuccess: (saved) => {
      // queryClient.setQueryData(['basicConfiguration', companyId], saved);
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_SETTINGS_TIMESHEET_BASIC, companyId],
      });
    },
  });
}
